import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { AppEnv } from "../../config/env";
import type { Database } from "../../types/database";

let browserClient: SupabaseClient<Database> | undefined;
let browserClientIdentity: string | undefined;

export function createSupabaseBrowserClient(
  appEnv: AppEnv,
): SupabaseClient<Database> {
  const identity = `${appEnv.VITE_SUPABASE_URL}:${appEnv.VITE_SUPABASE_PUBLISHABLE_KEY}`;

  if (browserClient && browserClientIdentity === identity) {
    return browserClient;
  }

  browserClient = createClient<Database>(
    appEnv.VITE_SUPABASE_URL,
    appEnv.VITE_SUPABASE_PUBLISHABLE_KEY,
    {
      auth: {
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: "pkce",
        persistSession: true,
        storage:
          typeof window !== "undefined" ? window.localStorage : undefined,
      },
    },
  );
  browserClientIdentity = identity;
  return browserClient;
}
